import React from 'react';
import { useRouter } from 'next/router';
import { connect } from 'react-redux';
import Section from '../common/Section';
import styles from '../../styles/modules/components/category-list-card.module.scss'
import Button from '../common/ui-components/input/Button';
import Slider from 'react-slick';
import { getStaticPath } from '../../utils/index'


interface CategoryListCardProps {
    list: {
        img: string,
        url: string,
        title: string,
    }[]
}

interface CategoryListItemProps {
    userCity?: any,
    img: string,
    url: string,
    title: string
}


const CategoryListCard = (props: CategoryListCardProps) => {
    const { list } = props;

    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: false,
        responsive: [
            {
                breakpoint: 9999,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    rows: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    rows: 2,
                }
            },
        ]
    };
    return (
        <Section className={`list-card`}>
            <div className={styles.selection} >
                <div className={`container ${styles.card_holder} slider-wrap`}>
                    <Slider  className={`${styles.slick_slider}`} {...settings}>
                        {list && list.map((item, index) => <CategoryListItem key={index} img={item.img} url={item.url} title={item.title} />)}
                    </Slider>
                </div>

            </div>

        </Section>
    )
}
const CategoryListItem = (props: CategoryListItemProps) => {
    const router = useRouter();
    let url = `/${props.url}`;
    return (
        // <div className="col-6 col-md-3 col-lg-3">
        <div className={`${styles.card}`}>

             <div className={styles._img}>
                <figure className={styles.img_icon} style={{backgroundImage:`url(${getStaticPath(`/static/images/common_pages/instarepair/${props.img}`)})`}}></figure>
            </div>

            <h2 className={styles._text}>{props.title}</h2>
            <Button className={styles.btn_submit} onClick={(e) => {
                e.preventDefault()
                localStorage.setItem('journey_starts_from', 'insta grid')
                router.push(url)
            }}>Explore Services</Button>

        </div>
        // </div>
    )
}

const mapStateToProps = (state) => {
  return {
      userCity: state.genericReducer.userCity
  }
}

export default connect(mapStateToProps, null)(CategoryListCard);
